"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchFetchCryptoExchangeAccessCode = exports.stytchFetchCryptoSignIn = exports.stytchFetchCryptoSignUp = void 0;
const query_string_1 = __importDefault(require("query-string"));
const headers_1 = require("../headers");
function stytchFetchCryptoSignUp(wallet, walletType, name, userServiceAddress, terms_accepted, enable_newsletter, source) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/crypto/signup`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            crypto_wallet_type: walletType,
            crypto_wallet_address: wallet,
            name: {
                first_name: name.firstName,
                middle_name: name.middleName,
                last_name: name.lastName,
            },
            terms_accepted,
            enable_newsletter,
            source,
        }),
    });
}
exports.stytchFetchCryptoSignUp = stytchFetchCryptoSignUp;
function stytchFetchCryptoSignIn(wallet, walletType, userServiceAddress) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/crypto/signin`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            crypto_wallet_type: walletType,
            crypto_wallet_address: wallet,
        }),
    });
}
exports.stytchFetchCryptoSignIn = stytchFetchCryptoSignIn;
function stytchFetchCryptoExchangeAccessCode(signature, wallet, walletType, userServiceAddress, isUserCreated, userId, termsAccepted, enableNewsletter) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/crypto/auth`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            signature,
            user_id: userId,
            crypto_wallet_address: wallet,
            crypto_wallet_type: walletType,
            user_created: isUserCreated,
            terms_accepted: termsAccepted,
            enable_newsletter: enableNewsletter,
        }),
    });
}
exports.stytchFetchCryptoExchangeAccessCode = stytchFetchCryptoExchangeAccessCode;
